import React, { useEffect, useState } from "react";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import { makeStyles, withStyles, Box } from "@material-ui/core";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import Alert from "@material-ui/lab/Alert";
import Grid from "@material-ui/core/Grid";

import LoaderView from "../../../components/LoaderView";
import { isEmptyObject } from "utils";

const useStyles = makeStyles({});

const ActivityHoursPlanned = (props) => {
  const {
    plannedActivityHoursData,
    plannedActivityHoursDataLoading,
    districtBuildingMapLoading,
  } = props;

  const classes = useStyles(),
    { t } = useTranslation();

  return (
    <>
      <LoaderView
        loading={plannedActivityHoursDataLoading || districtBuildingMapLoading}
      >
        {!isEmptyObject(plannedActivityHoursData) ? (
          // <ResponsiveContainer width="100%" height="100%">
          <BarChart
            width={730}
            height={50 * plannedActivityHoursData.length}
            data={plannedActivityHoursData}
            margin={{ left: 50 }}
            layout="vertical"
          >
            <XAxis type="number" hide axisLine={false} />
            <YAxis
              dataKey="activityName"
              orientation="left"
              type="category"
              axisLine={false}
              tickLine={false}
            />

            <Tooltip
              formatter={function (value, name) {
                return [`${value}`, "Duration"];
              }}
              labelFormatter={function (value) {
                return ``;
              }}
            />
            <Bar dataKey="activityHours" fill="#00a88e" />
          </BarChart>
        ) : (
          // </ResponsiveContainer>
          <Box className={classes.full}>
            <Alert severity="info">{t("pgHome.errNoReportData2")}</Alert>
          </Box>
        )}
      </LoaderView>
    </>
  );
};

export default ActivityHoursPlanned;
